export default __webpack_public_path__ + "static/media/dataset-header.15f27e13.svg";